<div id="left-menu-wrapper" class="bg-faded sticky-leftmenu sidebar" [class.expand]="sidebarSrv.isExpanded | async">
  <ng-container *ngTemplateOutlet="menuItem"></ng-container>
  <ng-container *ngTemplateOutlet="backItem"></ng-container>
  <ng-container *ngTemplateOutlet="listActions"></ng-container>
</div>



<!-- main item menu btn for collapse/expand sidebar -->
<!-- static component  -->
<ng-template #menuItem>
  <div class="sidebar-container menu" (click)="expandSidebar()">
    <a class="item" [class.expanded]="sidebarSrv.isExpanded | async">
      @if (sidebarSrv.isExpanded | async) {
      <span>Menu</span>
      }
      <span class="pi" [class.pi-angle-double-left]="sidebarSrv.isExpanded | async"
        [class.pi-angle-double-right]="!(sidebarSrv.isExpanded | async)"></span>
    </a>
  </div>
</ng-template>

<!-- back item for go back to the main section -->
<!-- static component  -->
<ng-template #backItem>
  @if (sidebarSrv.backEnabled | async) {
  <div class="sidebar-container actions" (click)="goBack()">
    <a class="item" [class.expanded]="sidebarSrv.isExpanded | async">
      @if (sidebarSrv.isExpanded | async) {
      <span>Indietro</span>
      }
      <span class="pi pi-arrow-left"></span>
    </a>
  </div>
  }
</ng-template>


<!-- list of the actions inside the sidebar -->
<ng-template #listActions>
  @for (action of sidebarSrv.actions | async; track $index) {
  <div>
    <div class="sidebar-container" (click)="goTo(action.routerLink)">
      <a class="item" [class.expanded]="sidebarSrv.isExpanded | async">
        @if (sidebarSrv.isExpanded | async) {
        <span pTooltip="{{action.title | translate}}" tooltipPosition="right"
          class="limit-text">{{action.title | translate}}</span>
        }
        <span [class]="appStateHolder.iconClass(action.icon)" pTooltip="{{action.title | translate}}"
          tooltipPosition="right"></span>
      </a>
    </div>
  </div>
  }

</ng-template>
